import apiClient from './client';

export const serviceNamesAPI = {
  getByBusinessType: (businessType) => apiClient.get('/service-names', { params: { businessType } }),
  add: (data) => apiClient.post('/service-names', data)
};
